import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-table-data", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("table-data", "sortable-table"),
            componentTag: "ux-table-data",
            pageWidth: 800,
            pageHeight: 540,
            performActions: async (page) => {
                await page.waitForSelector(".ux-table-data__th:nth-child(3)");
            },
        });
    });
});
